module.exports = __webpack_public_path__ + "img/_ms_.5470344d.svg";